import type { scaleLinear, scaleUtc } from '@visx/scale';

import { LinePlot } from '../TimeseriesPlot';

interface Props {
  data: [Date, number][];
  xScale: ReturnType<typeof scaleUtc<number>>;
  yScale: ReturnType<typeof scaleLinear<number>>;
}

export const BenchmarkPerformanceTimeseriesPlot = ({
  data,
  xScale,
  yScale,
}: Props) => {
  return (
    <svg aria-label="Benchmark Performance Timeseries Plot">
      <LinePlot
        data={data}
        xScale={xScale}
        yScale={yScale}
        strokeColor="var(--s-color-p-white-100)"
        opacity={0.5}
      />
    </svg>
  );
};
